import { ApiError } from './ApiError';

export class NotFoundError extends ApiError {
  constructor(message: string, errors: unknown[] = []) {
    super(404, message, errors);
    this.name = 'NotFoundError';
  }
}
